<template>
  <div class="loginDialogView">
    <el-dialog
      :visible.sync="loginVisible"
      :close-on-click-modal="true"
      width="818px"
      class="loginDialog"
      id="loginDialog"
      :before-close="close"
      :show-close="false"
      @open="openLogin()"
    >
      <div class="container row-center-start">
        <div
          class="left-conetnt content-item c-white
        px-30 py-50"
        >
          <p class="f-26 fw-700 pb-10 line-height">快哦</p>
          <p class="pb-30 f-18">电商企业智能工具平台</p>
          <p class="list-yu">3秒极速注册</p>
          <p class="list-yu">
            注册后免费检测<span style="font-style:oblique" class="f-18 fw-bold c-lightyellow px-5">50</span>张图片
          </p>
          <p class="list-yu">
            注册后<span class="f-18 fw-bold c-lightyellow px-5"><i style="font-style:oblique">永久免费</i></span
            >检测文字
          </p>
          <p class="list-yu">
            覆盖<span style="font-style:oblique" class="f-18 fw-bold c-lightyellow px-5">20+</span>行业，<span
              style="font-style:oblique"
              class="f-18 fw-bold c-lightyellow px-5"
              >10000+</span
            >个违禁词
          </p>
          <p class="list-yu">检测结果云端保存，实时可查</p>
          <p class="list-yu">一号可绑定多店，支持多人协同</p>
        </div>
        <div class="irght-content content-item">
          <div class="center mt-60">
            <!-- <canvas id="imgViewCanvas" width="75px" height="75px"></canvas> -->
            <img
              @click="scanning"
              v-if="loginMode == 1"
              @mouseover="rightTopIcon1 = require('../assets/index/zhmmIconH.png')"
              @mouseout="rightTopIcon1 = require('../assets/index/zhmmIcon.png')"
              style="position: absolute;top: 0;right: 0;cursor: pointer;"
              :src="rightTopIcon1"
              alt=""
            />
            <img
              @click="scanning"
              @mouseover="rightTopIcon2 = require('../assets/index/ewmIconH.png')"
              @mouseout="rightTopIcon2 = require('../assets/index/ewmIcon.png')"
              v-else
              style="position: absolute;top: 0;right: 0;cursor: pointer;"
              :src="rightTopIcon2"
              alt=""
            />
            <img
              v-if="loginMode == 1"
              style="position: absolute;top: 20px;right: 57px;"
              src="../assets/index/ewmTitle.png"
              alt=""
            />
            <img v-else style="position: absolute;top: 20px;right: 57px;" src="../assets/index/zhmmTitle.png" alt="" />

            <div class="title">
              <img v-show="loginMode == 1" src="../assets/index/wxIcon.png" alt="" />
              {{ loginMode == 1 ? "微信扫码登录/注册" : loginMode == 2 ? "密码登录 " : "验证码登录" }}
            </div>
            <div class="centerView" v-if="loginMode == 1">
              <div class="imgView" @click="toMode()" id="imgView">
                <img :src="wxImgUrl" alt="" :class="wxImgUrl == require('../assets/index/ewmNot.png') ? 'curp' : ''" />
              </div>
              <!-- <div class="textView mt15">
                <p style="text-align:left;margin-bottom:0">
                  <i class="el-icon-check" style="color:#212121"></i> 关注"大泽电商"公众号，<span style="color:#FF5F00"
                    >可领取专属权益</span
                  >
                </p>
                <p style="text-align:left;margin-bottom:0">
                  <i class="el-icon-check" style="color:#212121"></i> 关注"大泽电商"公众号，<span style="color:#FF5F00"
                    >可获得1688运营技巧学习</span
                  >
                </p>
              </div> -->
            </div>
            <div class="centerView" v-else-if="loginMode == 2 || loginMode == 3">
              <p>
                <el-input
                  placeholder="请输入手机号码"
                  type="text"
                  class="phoneInput"
                  clearable
                  v-model="phone"
                  maxlength="11"
                  name="userPhone"
                  v-onlyNum
                  @keyup.enter.native="handleLogin"
                  style="color: #000;"
                >
                  <i slot="prefix" style="color:#000;" class="ml5">+86</i>
                </el-input>
              </p>
              <p v-if="loginMode != 3">
                <el-input
                  placeholder="请输入6-20位密码"
                  class="phoneInput"
                  maxlength="20"
                  type="password"
                  name="password"
                  v-model="password"
                  @keyup.enter.native="handleLogin"
                  style="color: #000;"
                  :show-password="true"
                >
                  <i slot="prefix" style="color:#000;">密码</i>
                </el-input>
              </p>
              <p class="dfc" v-else-if="loginMode == 3">
                <el-input
                  placeholder="请输入验证码"
                  class="mr5"
                  :maxlength="4"
                  v-model="code"
                  clearable
                  @keyup.enter.native="handleLogin"
                >
                </el-input>
                <el-button
                  plain
                  :class="show ? 'getCodeBtn' : 'setCodeBtn'"
                  @click="getCode"
                  :style="show ? '' : 'width:158px'"
                  :disabled="!show"
                  >{{ show ? "获取验证码" : count + "s后可重发" }}</el-button
                >
              </p>
              <div style="display:flex;justify-content: space-between;">
                <a href="javascript:;" style="color:#2254F4;font-size:14px;" @click="toNote">{{
                  loginMode == 2 ? "验证码登录" : "密码登录 "
                }}</a>
                <a href="javascript:;" v-show="loginMode == 2" style="color:#222;font-size:14px;" @click="toChangePwd"
                  >忘记密码</a
                >
              </div>
              <div class="submitView mb20 mt30">
                <el-button type="primary" class="regBtn" @click="handleLogin">登录</el-button>
              </div>
              <div class="tips dfcjsb mt20">
                <p>登录即同意<span class="userPact curp" @click="toUserPact">《用户协议》</span></p>
                <p>
                  没有账号？
                  <a href="javascript:;" class="blueFont" @click="toReg">去注册 </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";

export default {
  props: [],
  components: {},
  data() {
    return {
      // loginMode:"1", // 1是微信扫码登录 2密码登录 3验证码登录
      title: "密码登录 ",
      loginDialogVisible: true,
      phone: "",
      password: "",
      show: true,
      clickMark: false, //连点拦截
      userInfoMark: false,
      count: "",
      code: "",
      wxImgUrl: require("../assets/index/ewmNot.png"),
      rightTopIcon1: require("../assets/index/zhmmIcon.png"),
      rightTopIcon2: require("../assets/index/ewmIcon.png"),
      timeImg: 0,
    };
  },
  computed: {
    ...mapState(["loginVisible", "userInfoCache", "shopToolToken", "loginMode", "Sign"]),
  },
  updated() {
    if (!this.userInfoMark) {
      this.$nextTick(() => {
        this.userInfoMark = true;
        if (this.userInfoCache && this.userInfoCache.hasOwnProperty("mobilePhone")) {
          this.phone = JSON.parse(JSON.stringify(this.userInfoCache.mobilePhone));
          this.password = JSON.parse(JSON.stringify(this.userInfoCache.password));
        }
      });
    }
  },
  mounted() {
    let self = this;

    this.$nextTick(() => {
      if (this.userInfoCache && this.userInfoCache.hasOwnProperty("mobilePhone")) {
        this.phone = JSON.parse(JSON.stringify(this.userInfoCache.mobilePhone));
        this.password = JSON.parse(JSON.stringify(this.userInfoCache.password));
      }
      // self.CanvasFun()
    });
  },
  created() {},
  methods: {
    // 测试canvas
    CanvasFun() {
      let self = this;
      var bg = document.getElementById("imgViewCanvas");
      console.log(bg);
      var ctx = bg.getContext("2d");
      var img = new Image();
      img.src = self.rightTopIcon1;
      img.onload = function() {
        ctx.drawImage(this, 0, 0);
      };
      ctx.beginPath();
      ctx.moveTo(75, 75);
      ctx.lineTo(0, 0);
      ctx.lineTo(75, 0);
      ctx.closePath(); //闭合路径
      var grd = ctx.createLinearGradient(0, 0, 0, 75); //从上到下
      ctx.strokeStyle = grd;
      ctx.stroke(); //绘制定义的图形
      bg.addEventListener("mousemove", function(e) {
        console.log(e);
        if (e.layerX - e.layerY >= 0) {
          if (self.loginMode == 1) {
            self.rightTopIcon1 = require("../assets/index/zhmmIconH.png");
          }
          //  @mouseover="rightTopIcon1 = require('../assets/index/zhmmIconH.png')" @mouseout="rightTopIcon1 = require('../assets/index/zhmmIcon.png')
          console.log("正常区域");
          img.src = self.rightTopIcon1;

          ctx.drawImage(this, 0, 0);
        } else {
          console.log("不正常区域");
          self.rightTopIcon1 = require("../assets/index/zhmmIcon.png");
          img.src = self.rightTopIcon1;

          ctx.drawImage(this, 0, 0, 74, 74);
        }
      });
      bg.addEventListener("mouseout", function(e) {
        console.log(e);
        self.rightTopIcon1 = require("../assets/index/zhmmIcon.png");
        self.rightTopIcon2 = require("../assets/index/ewmIcon.png");
        img.src = self.rightTopIcon1;
        ctx.drawImage(this, 0, 0);
      });
    },
    GetWxScanLogin(sign) {
      let self = this;
      self.interval = setInterval(function() {
        self.$ajax
          .get("/kuaio/api/Member/Member/GetWxScanLoginCallback?sign=" + sign)
          .then(function(res) {
            if (res.code == 200) {
              let result = res.result;
              let expirationTime = self.$utils.formatTime(result.expirationTime, "yyyy-MM-dd hh:mm:ss");
              let userInfo = {
                userPhone: result.mobilePhone,
                expirationTime,
                token: result.token,
                kuaiOId: result.kuaiOId,
                floatingShowFlag: true,
                // IndustryCategorys: ["通用"],
              };
              self.timeImg = 0;
              clearInterval(self.interval);
              localStorage.setItem("userInfo", JSON.stringify(userInfo));
              if (!self.$utils.getKuaioIdConfig()) {
                self.$utils.setKuaioIdConfig("IndustryCategorys", ["通用"]);
                self.$utils.setKuaioIdConfig("seleCheckThes", ["通用"]);
              }

              self.$store.commit("checkUserStatus");
              self.$utils.buryingpoint("快哦扫码后登录");
              self.$message.success({
                message: res.msg,
                duration: 1000,
                onClose: (res) => {
                  self.$emit("reload");
                  self.$store.commit("delSign");

                  self.close();
                },
              });
            } else if (res.code == 6000) {
              self.timeImg = 0;
              clearInterval(self.interval);
              self.$store.commit("checkeShopToolToken", sign);
              self.$store.commit("setLoginVisible", false);
              self.$store.commit("setWxBinding", true);
              setTimeout(() => {
                self.$store.commit("setRegVisible", true);
              }, 800);
            }
          })
          .catch(function(err) {
            clearInterval(self.interval);
            self.timeImg = 0;
            self.wxImgUrl = require("../assets/index/ewmNot.png");
          });
        if (self.timeImg == 0) {
          (self.wxImgUrl = require("../assets/index/ewmNot.png")), clearInterval(self.interval);
          return;
        } else {
          self.timeImg = self.timeImg - 1;
        }
      }, 1000);
    },
    // 登录弹窗打开后
    openLogin() {
      let self = this;
      if (this.loginVisible && this.loginMode == 1) {
        this.$store.state.Sign = this.$md5(String(new Date()) + String(new Date()) + "R" + this.random());
        // console.log(this.Sign)
        // let dataList = {
        //   type:2,
        //   data:	{"Sign":self.Sign}
        // }
        axios
          .get(
            "//api.fjdaze.com/weixinmp/api/DianShang/QrCode/Get?type=2&data=" +
              JSON.stringify({ Sign: self.Sign, Source: "快哦", Position: "登入弹窗" })
          )
          .then(function(res) {
            let data = res.data;

            if (data.code == 200) {
              self.timeImg = 60;
              self.GetWxScanLogin(self.Sign);
              self.$nextTick(function() {
                self.wxImgUrl = data.result.url;
                try {
                  self.loadingInstance.close();
                } catch (err) {}
              });
            } else {
              try {
                self.loadingInstance.close();
              } catch (err) {}
              self.$message.error(data.msg);
            }
          })
          .catch(function(err) {
            try {
              self.loadingInstance.close();
            } catch (err) {}

            self.$message.error("获取失败,请重试");
          });
      }
    },
    // 获得随机数字
    random() {
      let random = Math.round(Math.random() * 1000000);
      if (random == 0 || random == 1000000) {
        return String(Math.round(Math.random() * 1000000));
      } else {
        return String(random);
      }
    },
    //获取验证码
    getCode() {
      if (!this.phone) return this.$message.error("请输入正确的手机号");
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone)) return this.$message.error("请输入正确的手机号码");
      this.phone = Number(this.phone);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        let ajaxData = {
          mobilePhone: this.phone,
          verificationCodeType: 3,
        };
        this.$ajax
          .post("/kuaio/api/Member/Member/SentVerificationCode", ajaxData)
          .then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 1 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
            if (res.code != 200) this.$message.error(res.msg);
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    // 测试
    toMode() {
      let self = this;
      if (self.wxImgUrl == require("../assets/index/ewmNot.png")) {
        self.loadingInstance = this.$loading({
          target: "#imgView",
          customClass: "imgLoginClass",
          spinner: "el-icon-loading",
          text: "获取中",
        });
        self.openLogin();
        return;
      }
    },
    // 去注册
    toReg() {
      this.$store.commit("setLoginVisible", false);
      setTimeout(() => {
        this.$store.commit("setRegVisible", true);
      }, 300);
    },
    // 扫码登录
    scanning() {
      let self = this;
      try {
        self.loadingInstance.close();
      } catch (error) {}

      if (self.loginMode == 1) {
        self.timeImg = 0;
        clearInterval(self.interval);
        this.$store.state.loginMode = 3;
      } else {
        this.$store.state.loginMode = 1;
        self.timeImg = 0;
        clearInterval(self.interval);
        self.$nextTick(() => {
          self.openLogin();
        });
      }
    },
    // 验证码登录
    toNote() {
      let self = this;
      if (self.loginMode == 3) {
        this.$store.state.loginMode = 2;
      } else {
        this.$store.state.loginMode = 3;
      }
    },
    //忘记密码
    toChangePwd() {
      this.$store.commit("setLoginVisible", false);
      setTimeout(() => {
        this.$store.commit("setForgetVisible", true);
      }, 300);
    },
    // 登录
    async handleLogin() {
      let self = this;
      if (this.clickMark) return;
      this.clickMark = true;
      setTimeout(() => {
        this.clickMark = false;
      }, 3000);
      if (!this.phone) return this.$message.error("请输入正确的手机号码");
      if (self.loginMode == 2 && !this.password) return this.$message.error("请输入正确的密码");
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone)) return this.$message.error("请输入正确的手机号码");
      if (self.loginMode == 2 && (this.password.length < 6 || this.password.length > 20))
        return this.$message.error("请输入6-20位密码");
      this.phone = Number(this.phone);
      let pwdSalt = await this.getPwdSalt(this.phone);
      if (!pwdSalt) return;
      if (self.loginMode == 2) {
        let pwd = this.$md5(this.$md5(this.password) + pwdSalt);
        var ajaxData = {
          mobilePhone: this.phone,
          password: pwd,
          LoginType: 0,
        };
      } else {
        var ajaxData = {
          mobilePhone: this.phone,
          Code: self.code,
          LoginType: 1,
        };
      }

      let shopToolToken = this.shopToolToken;
      if (shopToolToken) ajaxData.shopToolToken = shopToolToken;
      const loading = this.$loading({
        text: "登录中",
        spinner: "el-icon-loading",
      });
      this.$ajax
        .post("/kuaio/api/Member/Login/Login", ajaxData)
        .then((res) => {
          this.userInfoMark = false;
          if (res.code == 200) {
            let result = res.result;
            let expirationTime = this.$utils.formatTime(result.expirationTime, "yyyy-MM-dd hh:mm:ss");
            let userInfo = {
              userPhone: this.phone,
              expirationTime,
              token: result.token,
              kuaiOId: result.kuaiOId,
              floatingShowFlag: true,
              // IndustryCategorys: ["通用"],
            };

            localStorage.setItem("userInfo", JSON.stringify(userInfo));
            if (!self.$utils.getKuaioIdConfig()) {
              self.$utils.setKuaioIdConfig("IndustryCategorys", ["通用"]);
              self.$utils.setKuaioIdConfig("seleCheckThes", ["通用"]);
            }
            this.$store.commit("checkUserStatus");
            if (self.loginMode == 2) {
              this.$utils.buryingpoint("快哦登陆");
            } else {
              this.$utils.buryingpoint("快哦验证码登录");
            }

            // this.$message.success(res.msg);
            this.$message({
              message: res.msg,
              type: "success",
              duration: 500,
            });

            setTimeout(function() {
              self.$emit("reload");
              self.close();
              window.location.reload();
            }, 1000);
          }
          if (res.code != 200) {
            this.$message.error(res.msg);
          }
          loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取密码盐
    getPwdSalt(mobilePhone) {
      let ajaxData = {
        mobilePhone: mobilePhone,
      };
      return new Promise((resolve, reject) => {
        this.$ajax
          .post("/kuaio/api/Member/Login/GetSalt", ajaxData)
          .then((res) => {
            if (res.code == 200) {
              resolve(res.result);
            }
            if (res.code != 200) {
              this.$message.error(res.msg);
              resolve(false);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    close() {
      this.$store.state.loginMode = 1;
      clearInterval(this.interval);
      try {
        this.loadingInstance.close();
      } catch (err) {}
      this.$store.commit("setLoginVisible", false);
      this.$store.commit("delShopToolToken");
    },
    //跳转到 用户协议
    toUserPact() {
      this.$emit("showUserPack");
      //this.$store.commit("setLoginVisible", false)
    },
  },
};
</script>
<style lang="scss">
.imgLoginClass {
  .el-loading-spinner {
    width: 100%;
    height: 100%;
    margin-top: 0;
    border-radius: 0;
    background: #ffffffe3;
    flex-direction: column;
    justify-content: center;
    .el-icon-loading {
      font-size: 30px;
    }
    .el-icon-loading,
    .circular {
      margin: 0 auto;
    }
  }
}
</style>
<style lang="scss" scoped>
.line-height {
  line-height: 1;
}
.container {
  width: 100%;
  height: 450px;
  border-radius: 8px;
  background-color: #fff;

  .content-item {
    height: 100%;
    & > .list-yu {
      padding: 4px 0 4px 25px;
      line-height: 1.6;
      position: relative;
      &::before {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        width: 16px;
        height: 16px;
        // background-color: #fff;
        content: "";
        background-image: url("../assets/icon_gouxua.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
    }
  }
  .left-conetnt {
    width: 348px;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-image: url("../assets/left-content.png");
  }
  .irght-content {
    width: calc(100% - 348px);
    // position: relative;
  }
}
#loginDialog {
  & > .el-dialog {
    & > .el-dialog__header {
      padding: 0;
    }
  }
}
.loginDialogView {
  .loginDialog {
    .center {
      padding: 0 60px;
      text-align: center;
      .centerView {
        padding: 0 20px;
        .getCodeBtn {
          background: #eee;
          border: 1px solid #eee;
          color: #000;
          width: 112px;
        }
        .setCodeBtn {
          background: #eee;
          border: 1px solid #eee;
          color: #999;
        }
        .imgView {
          height: 240px;
          width: 240px;
          margin: 0 auto;
          border: 1px solid #eee;
          img {
            display: block;
            width: 100%;
          }
        }
        .textView {
          position: absolute;
          bottom: 0;
          width: 100%;
          background: #fff9e3;
          font-size: 12px;
          padding: 15px 25px;
          line-height: 20px;
          left: 0;
        }
      }
      .title {
        font-size: 18px;
        color: #000;
        font-weight: 600;
        margin-top: 20px;
        margin-bottom: 40px;
      }
      p {
        margin-bottom: 15px;
      }
      .getCodeBtn {
        background: #eee;
        border: 1px solid #eee;
        color: #000;
      }
      .regBtn {
        width: 100%;
      }
      .tips {
        color: #aaa;
        .userPact {
          color: #333;
        }
        .userPact {
          color: #aaa;
        }
        .userPact:hover {
          //color: #1c64f4;
          color: #aaa;
        }
      }
      a:hover {
        color: #1c64f4;
      }
    }
    .newReg {
      height: 100px;
      background: #fffae4;
      border-radius: 0 0 6px 6px;
      .item {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding-left: 25px;
        padding-top: 10px;
        p {
          width: 50%;
          margin-bottom: 10px;
        }
        .el-icon-check {
          color: #000;
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.loginDialogView {
  border-radius: 8px;
  overflow: hidden;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__headerbtn {
    font-size: 20px;
  }
  .el-dialog {
    background: transparent;
    height: 450px;
  }
  .el-dialog__body {
    padding: 0;
  }
  .phoneInput {
    .el-input__prefix {
      display: flex;
      align-items: center;
      left: 8px;
    }
    .el-input__inner {
      color: #000;
      padding-left: 48px;
    }
  }
}
</style>
